import { render, staticRenderFns } from "./otherPoints.vue?vue&type=template&id=38f5eb26&scoped=true"
import script from "./otherPoints.vue?vue&type=script&lang=js"
export * from "./otherPoints.vue?vue&type=script&lang=js"
import style0 from "./otherPoints.vue?vue&type=style&index=0&id=38f5eb26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f5eb26",
  null
  
)

export default component.exports